import React, { useContext,useEffect,useState } from 'react'
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Input from '../Input'
import { ProductsContext } from '../../context/products';


const CardWrapper = styled.section`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    p{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        text-align: center;
        margin-bottom: 0rem;
        font-size: 1.3rem;

        b{
            font-size: 1rem;
        }

    }



`
const ImagePreview = styled.img`
    width: 130px;
    height: 130px;
    margin: 0 auto;
    object-fit: contain;
    border-radius: 100px;
`

const ModalConfirmTrash = ({ props }) => {
    const {
        editProductData,
        deleteProduct,
    } = useContext(ProductsContext)

    const handleCancelClick = () => {
        props.onHide(); // 
    }

    const handleConfirm = () => {
        props.onHide(); // 
        deleteProduct(editProductData?.product_id)
    }



    return (
        
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered

        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Atenção!
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <CardWrapper>

                    <p className='textPrimary'>Deseja realmente excluir o produto <br/><b>{editProductData?.name}</b> ?</p>
                
                </CardWrapper>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => handleCancelClick()}>Cancelar</Button>
                <Button variant="danger" onClick={() => handleConfirm()}>Confirmar</Button>

            </Modal.Footer>
        </Modal>
    )
}

export default ModalConfirmTrash